import { render } from "./hz-button.vue?vue&type=template&id=56eac480"
import script from "./hz-button.vue?vue&type=script&setup=true&lang=js"
export * from "./hz-button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/button/hz-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56eac480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56eac480', __exports__)) {
    api.reload('56eac480', __exports__)
  }
  
  module.hot.accept("./hz-button.vue?vue&type=template&id=56eac480", () => {
    api.rerender('56eac480', render)
  })

}


export default __exports__